import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    item: {
        backgroundColor: '#d5f2ff',
        borderRadius:'4px',
        padding:'4px 10px',
        fontSize:'10px',
        color:'#256c8e'
    }
}